import { forwardRef, type ComponentProps } from 'react'
import ReactTextareaAutosize from 'react-textarea-autosize'

import { cn } from '@/lib/utils'

const Textarea = forwardRef<
  HTMLTextAreaElement,
  ComponentProps<typeof ReactTextareaAutosize>
>(({ className, minRows = 3, maxRows = 12, ...props }, ref) => {
  return (
    <ReactTextareaAutosize
      ref={ref}
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 w-full rounded-md border bg-white px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      minRows={minRows}
      maxRows={maxRows}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
